<template>
  <v-dialog
    v-model="localDialog"
    width="70%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span class="text-center">Supplier Payment</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-table class="bg-purple-lighten-5" density="compact">
              <thead>
                <tr>
                  <th colspan="2" class="text-left">
                    Payment Summary
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Invoice No.</td>
                  <td>{{ code }}</td>
                </tr>
                <tr>
                  <td>Total </td>
                  <td>{{ total }}</td>
                </tr>
                <tr>
                  <td>Net Paid </td>
                  <td>{{ paid_amount = payments.reduce((prev, curr) => { return +prev + +curr.net_payment }, 0) }}</td>
                </tr>
                <tr>
                  <td>Discount </td>
                  <td>{{ paid_amount = payments.reduce((prev, curr) => { return +prev + +curr.discount }, 0) }}</td>
                </tr>
                <tr>
                  <td>Total Paid </td>
                  <td>{{ paid_amount = payments.reduce((prev, curr) => { return +prev + +curr.amount }, 0) }}</td>
                </tr>
                <tr>
                  <td>Due </td>
                  <td>{{ due }}</td>
                </tr>
                
              </tbody>
            </v-table>

            <v-table class=" mt-2" density="compact">
              <thead>
                <tr>
                  <th colspan="5" class="text-left">
                    Payment Records
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Payment Date</th>
                  <td>Payment Type</td>
                  <td>Net Payment</td>
                  <td>Discount</td>
                  <td>Total</td>
                </tr>
                <tr v-for="item in payments" :key="item">
                  <td>{{ item.payment_date }}</td>
                  <td>{{ item.payment_type }}</td>
                  <td>{{ item.net_payment }}</td>
                  <td>{{ item.discount }}</td>
                  <td>{{ item.amount }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
          <v-col cols="6">
            <v-form @submit.prevent="submit" ref="SupplierPaymentSetup">
              <v-row>
                <v-col cols="6">     
                  <v-date-input
                    input-format="dd/mm/yyyy"
                    prepend-icon=""
                    prepend-inner-icon="mdi-calendar"
                    density="compact"
                    variant="outlined"
                    bg-color="grey-lighten-4"
                    v-model="payment_date.value.value"
                    :error-messages="payment_date.errorMessage.value"
                    hide-details="auto"
                    autocomplete="off"
                    clearable
                  >
                    <template #label>
                      Payment Date
                      <span class="text-red-accent-4">*</span>
                    </template>
                  </v-date-input>
                </v-col>

                <v-col cols="6">
                  <v-select 
                    variant="outlined" 
                    density="compact"
                    bg-color="grey-lighten-4"
                    v-model="payment_type.value.value" 
                    :items="paymentTypes"
                    :item-title="(item) => `${item.label}`"
                    item-value="value" 
                    :error-messages="payment_type.errorMessage.value"
                    @update:modelValue="onPaymentTypeChange"
                    hide-details="auto"
                    autocomplete="off"
                  
                      :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                    <template #label>
                      Payment Type
                      <span class="text-red-accent-4">*</span>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12">
                    <v-select 
                      label="Account No"
                      variant="outlined" 
                      density="compact"
                      bg-color="grey-lighten-4"
                      v-model="payment_acc_head.value.value"
                      :items="getPaymentAccountHeadList"
                      :item-title="(item) => `${item.name}`"
                      item-value="id" 
                      hide-details="auto"
                      :error-messages="payment_acc_head.errorMessage.value"
                      autocomplete="off"
                    
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                </v-col>

                <v-col cols="12" class="pa-0" v-if="payment_type.value.value === 'BANK' && payment_acc_head.value.value ">
                  <v-row class="pa-0 ma-0">
                    <v-col cols="12" class="pb-0">
                      <v-select
                        v-model="selectChequeMethod"
                        :items="getChequeMethod"
                        item-title="text"
                        item-value="value"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
                    </v-col>

                    <v-col v-if="selectChequeMethod === ''" cols="6" class="pb-0 pt-0">
                      <v-select
                        v-model="cheque_id.value.value"
                        :items="getChequeList"
                        :item-title="(item) => item.cheque_no"
                        item-value="id"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        label="Select Cheque No."
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
                    </v-col>

                    <v-col v-if="selectChequeMethod === 'enter-cheque'" cols="6" class="pb-0 pt-0"> 
                      <v-text-field 
                        label="Enter Cheque Number" 
                        density="compact"
                        variant="outlined" 
                        bg-color="grey-lighten-4"
                        v-model="cheque_no.value.value"
                        hide-details="auto"
                        :error-messages="cheque_no.errorMessage.value"
                        autocomplete="off" 
                      />
                    </v-col>

                    <v-col cols="6" class="pb-0 pt-0">
                      <v-date-input 
                        input-format="dd/mm/yyyy"
                        label="Cheque Issue Date"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-icon="" 
                        v-model="cheque_issue_date.value.value" 
                        variant="outlined"
                        hide-details="auto"
                        :error-messages="cheque_issue_date.errorMessage.value"
                        autocomplete="off"
                      ></v-date-input>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col v-if="payment_type.value.value === 'MOBILE_BANKING'" cols="6">
                  <v-autocomplete 
                    density="compact" 
                    variant="outlined"
                    bg-color="grey-lighten-4"
                    label="Provider"
                    v-model="mobileProvider.value.value"
                    :items="mobileProviders"
                    item-title="label"
                    item-value="value" 
                    hide-details="auto"
                    :error-messages="mobileProvider.errorMessage.value"
                    autocomplete="off"
                  
                      :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                  </v-autocomplete>
                </v-col>

                <v-col v-if="payment_type.value.value === 'MOBILE_BANKING'" cols="6">
                  <v-text-field
                    density="compact"
                    variant="outlined" 
                    bg-color="grey-lighten-4"
                    label="Transaction ID"
                    v-model="transactionId.value.value"
                    hide-details="auto"
                    :error-messages="transactionId.errorMessage.value"
                    autocomplete="off" 
                  />
                </v-col>

                <v-col cols="6" md="6">
                  <v-text-field 
                    label="Amount"
                    density="compact" 
                    variant="outlined" 
                    type="number"
                    bg-color="grey-lighten-4"
                    v-model="amount.value.value"
                    @update:model-value="paymentCalculate"
                    hide-details="auto"
                    :error-messages="amount.errorMessage.value"
                    autocomplete="off"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="6" md="6">
                  <v-text-field 
                    label="Discount" 
                    density="compact"
                    variant="outlined" 
                    type="number"
                    bg-color="grey-lighten-4"
                    v-model="discount.value.value"
                    :error-messages="discount.errorMessage.value"
                    @update:model-value="paymentCalculate"
                    hide-details="auto"
                    autocomplete="off"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <v-text-field 
                    density="compact" 
                    variant="outlined" 
                    bg-color="grey-lighten-4"
                    type="number"
                    v-model="net_payment.value.value"
                    :error-messages="net_payment.errorMessage.value"
                    hide-details="auto"
                    autocomplete="off"
                    readonly
                  >
                    <template #label>
                      Net Payment
                      <span class="text-red-accent-4">*</span>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <v-date-input 
                    input-format="dd/mm/yyyy"
                    label="Next Payment Date"
                    density="compact" 
                    variant="outlined" 
                    bg-color="grey-lighten-4"
                    prepend-icon="" 
                    prepend-inner-icon="mdi-calendar"
                    v-model="next_payment_date.value.value"
                    :error-messages="next_payment_date.errorMessage.value"
                    hide-details="auto"
                    autocomplete="off"
                  >
                    <template #label>
                      Next Payment Date
                    </template>
                  </v-date-input>
                </v-col>

                <v-col cols="12" md="12">
                  <v-textarea 
                    label="Description" 
                    density="compact" 
                    variant="outlined"
                    bg-color="grey-lighten-4" 
                    v-model="description.value.value"
                    :error-messages="description.errorMessage.value" 
                    autocomplete="off"
                    rows="3" 
                    hide-details="auto"
                    clearable
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-card-actions>
                <v-layout class="justify-end">
                  <v-btn
                    class="bg-red"
                    variant="flat"
                    type="reset"
                    @click="closeDialog"
                  >Close</v-btn>
                  <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">Save</v-btn>
                </v-layout>
              </v-card-actions>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import axios from "axios";
import { getSupplierPaymentById } from "@/store/api";
import { getCurrentInstance } from "vue";


export default {
  name: "SupplierPaymentSetup",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        status: "1",
      }),
    },
  },
  emits: ['update:dialog'],
  data() {
    return {
      localDialog: this.dialog,
      selectedImage: null,
      errorMessages: "",
      loading: false,
      code: '',
      total: '',
      paid: '',
      due: '',
      selectChequeMethod: '',
      paid_amount: '',
      paymentTypes: [
        { label: "Cash", value: "CASH" },
        { label: "Bank", value: "BANK" },
        { label: "Mobile Banking", value: "MOBILE_BANKING" }
      ],
      mobileProviders: [
        { label: "Bkash", value: "bkash" },
        { label: "Nagad", value: "nagad" },
        { label: "Rocket", value: "rocket" }
      ],
      payments: []
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    selectChequeMethod(val) {
      const queryId = this.$route.query.id;

      if (queryId) return;
      this.cheque_no.value.value = '';
      this.cheque_id.value.value = null;
    },

    "payment_acc_head.value.value": {
      handler(newVal) {
        if (newVal) {
          this.$store.dispatch("getChequeList", {
            acc_account_head_id: newVal,
          });
        }
      },
    },

    "cheque_id.value.value": {
      handler(newVal) {
        if (newVal) {
          this.$store.dispatch("getChequeById", newVal).then((res) => {
            this.cheque_no.value.value = res[0].cheque_no;
          })
        }
      },
    },
    data: {
      handler(newData) {
        console.log("Invoice data received:", newData);
        this.resetForm({ errors: {}, touched: {} });
        this.status.setValue(String(newData.status) || "1", false);

        // Check if this is Asset Acquisition or PO Receive type invoice
        const isAssetAcquisition = newData.asset_acquisition_master_id || newData.acquisition_master_id;
        
        // Always set invoice master id (payment is against the invoice)
        this.pur_order_invoice_master_id.setValue(newData.id || "", false);
        
        if (isAssetAcquisition) {
          // Asset Acquisition flow
          this.asset_register_acquisition_master_id.setValue(newData.acquisition_master_id || newData.asset_acquisition_master_id || "", false);
          // Need to fetch pur_order_master_id from asset acquisition if needed
          this.fetchPurOrderMasterId(newData, true);
        } else {
          // PO Receive flow
          this.asset_register_acquisition_master_id.setValue(null, false);
          // Need to fetch pur_order_master_id from po receive
          this.fetchPurOrderMasterId(newData, false);
        }
        
        this.supplier_id.setValue(newData.supplier_id || "", false);
        this.amount.setValue(newData.due || newData.total || 0, false);
        this.code = newData.code;
        this.total = newData.total;
        this.paid = newData.paid || 0;
        this.due = newData.due || newData.total;
        this.paid_amount = 0;
        this.payment_date.setValue(new Date(), false);
        this.next_payment_date.setValue(new Date(), false);

        // Get payments based on invoice id
        if (this.pur_order_invoice_master_id.value.value) {
          this.getSupplierPayments(this.pur_order_invoice_master_id.value.value);
        }
      },
    },
  },
  created() {
    
  },
  computed: {
    getChequeMethod() {
      const method = [
        { text: "Select Cheque No.", value: "" },
        { text: "Enter Cheque No.", value: "enter-cheque" },
      ]
      return method;
    },
    getChequeList() {
      return this.$store.getters.getChequeList;
    },
    getPaymentAccountHeadList() {
      return this.$store.getters.getPaymentAccountHeadList;
    },
  },
  methods: {
    async fetchPurOrderMasterId(invoiceData, isAssetAcquisition) {
      try {
        if (isAssetAcquisition) {
          // Fetch from asset acquisition
          const acquisitionId = invoiceData.acquisition_master_id || invoiceData.asset_acquisition_master_id;
          if (acquisitionId) {
            const response = await this.$store.dispatch("getAssetAcquisitionById", acquisitionId);
            const purOrderMasterId = response.pur_order_master_id || response.data?.pur_order_master_id;
            this.pur_order_master_id.setValue(purOrderMasterId || "", false);
            console.log("Fetched pur_order_master_id from asset acquisition:", purOrderMasterId);
          }
        } else {
          // Fetch from PO receive
          const poReceiveId = invoiceData.inv_po_receive_master_id;
          if (poReceiveId) {
            const response = await this.$store.dispatch("getInvPoReceiveById", poReceiveId);
            const purOrderMasterId = response.pur_order_master_id || response.data?.pur_order_master_id;
            this.pur_order_master_id.setValue(purOrderMasterId || "", false);
            console.log("Fetched pur_order_master_id from PO receive:", purOrderMasterId);
          }
        }
      } catch (error) {
        console.error("Failed to fetch pur_order_master_id:", error);
        this.pur_order_master_id.setValue("", false);
      }
    },
    async onPaymentTypeChange() {
      if (this.payment_type.value.value) {
        await this.$store.dispatch("getPaymentAccountHeadList", { type: this.payment_type.value.value });
        this.payment_acc_head.value.value = null;
      }
    },
    paymentCalculate() {
      const amount = parseFloat(this.amount.value.value) || 0;
      const discount = parseFloat(this.discount.value.value) || 0;
      const netPayment = parseFloat(+amount - +discount);
      this.net_payment.value.value = Number(netPayment.toFixed(2));
    },
    async getSupplierPayments(id) {
      axios.get(getSupplierPaymentById + '/' + id).then((response) => {
        const data = response.data.data;
        console.log(data);
        this.payments = data;
      })
      .catch((error) => {
        console.error(error);
        this.payments = [];
      })
    },
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        pur_order_invoice_master_id: yup.number().required().label("Purchase Invoice No"),
        asset_register_acquisition_master_id: yup.number().nullable().label("Asset Acquisition Master No"),
        pur_order_master_id: yup.number().required().label("Purchase Order No"),
        payment_date: yup.date().required().label("Payment Date"),
        payment_type: yup.string().required().label("Payment Type"),
        amount: yup.number().required().label("Amount"),
        discount: yup.number().nullable().label("Discount"),
        net_payment: yup.number().required().label("Net Payment"),
        next_payment_date: yup.date().nullable().label("Next Payment Date"), 
        payment_acc_head: yup.number().required().label("Payment Account Head"),
        cheque_no: yup.string().nullable().when("payment_type", { is: "BANK", then: (schema) => schema.required("Cheque No is required"),  otherwise: (schema) => schema.nullable(),}),
        cheque_id: yup.string().nullable().when("payment_type", { is: "BANK", then: (schema) => schema.nullable(), otherwise: (schema) => schema.nullable(),}),
        cheque_issue_date: yup.date().nullable().when("payment_type", { is: "BANK", then: (schema) => schema.required("Cheque Issue Date is required"),  otherwise: (schema) => schema.nullable(),}),
        mobileProvider: yup.string().nullable().when("payment_type", { is: "MOBILE_BANKING", then: (schema) => schema.required("Provider is required"),  otherwise: (schema) => schema.nullable(),}),
        transactionId: yup.string().nullable().when("payment_type", { is: "MOBILE_BANKING",  then: (schema) => schema.required("Transaction ID is required"), otherwise: (schema) => schema.nullable(),}),
        status: yup.string().required().label("Status"),
      }),
    });
    const pur_order_invoice_master_id = useField("pur_order_invoice_master_id");
    const asset_register_acquisition_master_id = useField("asset_register_acquisition_master_id");
    const pur_order_master_id = useField("pur_order_master_id");
    const supplier_id = useField("supplier_id");
    const payment_date = useField("payment_date");
    const payment_type = useField("payment_type");
    const payment_acc_head = useField("payment_acc_head");
    const amount = useField("amount");
    const discount = useField("discount");
    const net_payment = useField("net_payment");
    const cheque_issue_date = useField("cheque_issue_date");
    const cheque_no = useField("cheque_no");
    const cheque_id = useField("cheque_id");
    const transactionId = useField("transactionId");
    const mobileProvider = useField("mobileProvider");
    const next_payment_date = useField("next_payment_date");
    const description = useField("description");

    const status = useField("status");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const submit = handleSubmit((values) => {
      console.log(values)
      values.payment_date = payment_date.value.value ? formattedDate(payment_date.value.value) : null;
      values.cheque_issue_date = cheque_issue_date.value.value ? formattedDate(cheque_issue_date.value.value) : null;
      values.next_payment_date = next_payment_date.value.value ? formattedDate(next_payment_date.value.value) : null;

      if (payment_type.value.value === "BANK") {
        if (proxy.selectChequeMethod === '') {
          // Dropdown selection - send cheque_id
          values.cheque_id = cheque_id.value.value;
          values.cheque_no = cheque_no.value.value;
        } else if (proxy.selectChequeMethod === 'enter-cheque') {
          // Manual entry - send cheque_no
          values.cheque_id = null;
          values.cheque_no = cheque_no.value.value;
        }
      } else {
        values.cheque_id = null;
        values.cheque_no = null;
        values.cheque_issue_date = null;
      }

      // Determine which type of invoice this is and set the correct field
      const isAssetAcquisition = values.asset_register_acquisition_master_id;
      
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        // Append all non-empty values
        if (values[key] !== null && values[key] !== undefined && values[key] !== '') {
          formData.append(key, values[key]);
        }
      });

      store
        .dispatch("saveSupplierPayment", formData)
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          emit("update-success");
          toast.success(response.data.message);
          loading.value = true;
          Promise.all([
            store.dispatch("getPurInvoiceList", {}),
          ]).finally(() => {
            loading.value = false;
          });
        })
        .catch((error) => {
          console.log(error.response)
          toast.error(error.response?.data?.message);
        });
    });
    return {
      submit,
      pur_order_invoice_master_id,
      asset_register_acquisition_master_id,
      pur_order_master_id,
      supplier_id,
      payment_date,
      payment_type,
      payment_acc_head,
      amount,
      discount,
      net_payment,
      cheque_no,
      cheque_id,
      cheque_issue_date,
      transactionId,
      mobileProvider,
      description,
      next_payment_date,
      errorMessages,
      resetForm,
      status,
      loading,
    }
  },
  mounted() {
    this.amount.value.value = 0
    this.discount.value.value = 0
    this.status.value.value = 1;
    this.payment_date.value.value = new Date();
    this.next_payment_date.value.value = new Date();
  },
};
</script>

